export { default } from "../routes/AppRouter";
